import HeroSection from '../components/hero/HeroSection';
import AgentCarousel from '../components/agents/AgentCarousel';

interface HomePageProps {
  onLogoEasterEgg: () => void;
}

const HomePage = ({ onLogoEasterEgg }: HomePageProps) => {
  return (
    <div className="min-h-screen pt-16">
      {/* Hero Section with Floating Avatar */}
      <HeroSection onLogoEasterEgg={onLogoEasterEgg} />

      {/* Agent Carousel Section */}
      <AgentCarousel />

      {/* CTA Button */}
      <div className="flex flex-col items-center justify-center py-20 px-4">
        <a
          href="https://macmind.macpherson.ai"
          className="px-8 py-4 bg-green-500 hover:bg-green-400 text-black text-xl font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl"
        >
          Enter The Mind
        </a>
      </div>
    </div>
  );
};

export default HomePage;
